<section>
  <app-head-generative-ai selectedNavItem="issues"></app-head-generative-ai>
  <div class="container m-b-xxl m-t-alt">
    <div class="columns">
      <div
        class="column is-12-mobile is-10-tablet is-offset-1-tablet is-8-desktop is-offset-2-desktop"
      >
        <div class="mb-5">
          <a
            routerLink="/genai/issues/{{ tab.slug }}"
            class="button is-link ml-0 mr-4 mb-4"
            *ngFor="let tab of tabs"
            [ngClass]="{ 'is-outlined': tab.anchor !== title }"
            >{{ tab.anchor }}</a
          >
        </div>
      </div>
    </div>

    <div class="columns is-multiline">
      <div
        class="column is-12-mobile is-10-tablet is-offset-1-tablet is-8-desktop is-offset-2-desktop"
      >
        <h2 class="title is-2 mb-0">{{ title }}</h2>

        <div *ngIf="page?.content" [innerHTML]="page.content"></div>

        <!-- Loading -->
        <div *ngIf="!page">
          <div
            class="mt-6 temporary-item temporary-item--dark temporary-desc"
          ></div>
          <div class="temporary-item temporary-item--dark temporary-desc"></div>
          <div class="temporary-item temporary-item--dark temporary-desc"></div>
          <div class="temporary-item temporary-item--dark temporary-desc"></div>
          <div class="temporary-item temporary-item--dark temporary-desc"></div>
        </div>
      </div>
    </div>
  </div>
</section>
